module.exports = __webpack_public_path__ + "img/powerGrid-icon_5.1bd2975b.png";